import type { OptimizationGroupModel } from '@/shared/generated'

import { useNavigate } from '@tanstack/react-router'
import { filter, orderBy, pipe } from 'lodash/fp'

import {
	getOgStatus,
	getOptimizationsMap,
	getStatusScheme,
	useOptimizationsQuery,
} from '@/entities/optimization'
import { useOptimizationGroupsQuery } from '@/entities/optimization-group'

import { Spinner } from '@/shared/components/ui/spinner'
import {
	Table,
	TableBody,
	TableCell,
	TableRow,
} from '@/shared/components/ui/table'

export default function OptimizationGroupsTooltipList({
	ids,
}: {
	ids: string[]
}) {
	const navigate = useNavigate()
	const groupsQuery = useOptimizationGroupsQuery({
		select: pipe([
			filter((og: OptimizationGroupModel) => ids.includes(og.id)),
			orderBy(['name'], ['asc']),
		]),
	})
	const optimiztionsQuery = useOptimizationsQuery({
		select: getOptimizationsMap,
	})

	return (
		<Table className='bg-transperent flex w-fit rounded p-2 text-xs whitespace-nowrap'>
			<TableBody>
				{groupsQuery.data?.map((og: OptimizationGroupModel) => {
					const optimization = optimiztionsQuery.data?.[og.id]

					return (
						<TableRow
							key={og.id}
							className="relative border-none bg-transparent before:absolute before:-inset-x-0.5 before:inset-y-0 before:rounded-sm before:bg-muted before:opacity-0 before:content-[''] hover:cursor-pointer hover:before:opacity-100 dark:before:bg-background/50"
							onClick={() => navigate({ to: `/p/og/${og.id}/products` })}
						>
							<TableCell className='relative p-1 text-muted-foreground'>
								{optimiztionsQuery.isFetching ? (
									<Spinner className='shrink-0' />
								) : (
									<span
										className='flex size-3 shrink-0 rounded'
										style={{
											backgroundColor: getStatusScheme(
												getOgStatus(optimization?.status)
											).color,
										}}
									/>
								)}
							</TableCell>
							<TableCell className='relative p-1 pl-3 text-left font-mono'>
								{og.name}
							</TableCell>
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}
